import { Outlet } from 'react-router-dom';
import { PublicNav } from './public-nav';
import { PublicFooter } from './footer';
import { ScrollToHash } from '@/components/shared/scroll-to-hash';

export function PublicShell() {
  return (
    <div className="flex min-h-dvh flex-col">
      <ScrollToHash />
      <PublicNav />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
